import React, { useState } from 'react';
import './Contact.css';

import { db } from '../../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

import emailjs from '@emailjs/browser';

const Contact = () => {
  const [form, setForm] = useState({
    intent: 'book',
    name: '',
    phone: '',
    email: '',
    eventDate: '',
    eventType: '',
    eventPlace: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleIntent = (intent) => {
    setForm({
      ...form,
      intent,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      console.log('Form Data:', form);
      // Save to Firebase
      await addDoc(collection(db, 'enquiries'), {
        ...form,
        createdAt: serverTimestamp(),
      });

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          intent: form.intent,
          name: form.name,
          phone: form.phone,
          email: form.email,
          event_date: form.eventDate,
          event_type: form.eventType,
          event_place: form.eventPlace,
          message: form.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setSubmitted(true);
    } catch (err) {
      console.log(err);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-sec" id="contact">
      <div className="container">
        <div className="contact-inner">
          {/* LEFT */}
          <div className="contact-left reveal">
            <span className="sec-label" style={{ color: 'var(--org)' }}>
              Let's talk
            </span>

            <h2 className="sec-h2" style={{ color: '#fff' }}>
              Ready to <em>GoSnap?</em>
            </h2>

            <p
              style={{
                color: 'rgba(255,255,255,0.55)',
                lineHeight: 1.8,
                fontWeight: 300,
                marginBottom: '2rem',
              }}
            >
              Book premium instant reel creators for weddings, birthdays,
              events, celebrations & unforgettable moments.
            </p>

            <div className="contact-info">
              <div className="ci-item">
                <div className="ci-icon">📍</div>
                <div>
                  <div className="ci-label">Location</div>
                  <div className="ci-val">Hyderabad, Telangana, India</div>
                </div>
              </div>

              <div className="ci-item">
                <div className="ci-icon">✉️</div>
                <div>
                  <div className="ci-label">Email</div>
                   <a
      href="mailto:connect.gosnap@gmail.com"
      className="ci-val ci-link"
    >
      connect.gosnap@gmail.com
    </a>
                </div>
              </div>

              <div className="ci-item">
                <div className="ci-icon">📱</div>
                <div>
                  <div className="ci-label">WhatsApp</div>
                   <a
      href="https://wa.me/918978100740"
      target="_blank"
      rel="noopener noreferrer"
      className="ci-val ci-link"
    >
      +91 89781 00740
    </a>
              <br />
    <a
      href="https://wa.me/917702254457"
      target="_blank"
      rel="noopener noreferrer"
      className="ci-val ci-link"
    >
      +91 77022 54457
    </a>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="contact-right reveal rd1">
            {submitted ? (
              <div className="success-screen">
                <div className="success-glow"></div>

                <div className="success-icon">
                  🎉
                </div>

                <h2>Booking Request Sent!</h2>

                <p>
                  Thank you for choosing GoSnap ✨
                  <br />
                  Our team is currently reviewing your request and will
                  contact you shortly.
                </p>

                <div className="success-note">
                  Kindly wait while we prepare something cinematic for you 🎬
                </div>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                {/* INTENT */}
                <div className="form-group">
                  <label>I want to</label>

                  <div className="intent-pills">
                    {['book', 'partner', 'join', 'other'].map((opt) => (
                      <button
                        key={opt}
                        type="button"
                        className={`intent-pill ${
                          form.intent === opt ? 'active' : ''
                        }`}
                        onClick={() => handleIntent(opt)}
                      >
                        {opt === 'book'
                          ? '📅 Book a Creator'
                          : opt === 'partner'
                          ? '🤝 Partner with GoSnap'
                          : opt === 'join'
                          ? '🎥 Join as Creator'
                          : '💬 Other'}
                      </button>
                    ))}
                  </div>
                </div>

                {/* BOOK A CREATOR */}
                {form.intent === 'book' ? (
                  <>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Name</label>
                        <input
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          placeholder="Your name"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Mobile</label>
                        <input
                          name="phone"
                          value={form.phone}
                          onChange={handleChange}
                          placeholder="+91 98765 43210"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Event Date</label>
                        <input
                          type="date"
                          name="eventDate"
                          value={form.eventDate}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Event Type</label>

                        <select
                          name="eventType"
                          value={form.eventType}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select</option>
                          <option>Wedding</option>
                          <option>Birthday</option>
                          <option>Haldi</option>
                          <option>Engagement</option>
                          <option>Baby Shower</option>
                          <option>Corporate Event</option>
                          <option>Concert</option>
                          <option>House Party</option>
                          <option>Other</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Event Place</label>
                      <input
                        name="eventPlace"
                        value={form.eventPlace}
                        onChange={handleChange}
                        placeholder="Venue / Location"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="you@email.com"
                      />
                    </div>

                    <div className="form-group">
                      <label>Additional Details</label>
                      <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        placeholder="Tell us about your event..."
                        rows={4}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {/* OTHER FORMS */}
                    <div className="form-row">
                      <div className="form-group">
                        <label>Name</label>
                        <input
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          placeholder="Your name"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Phone</label>
                        <input
                          name="phone"
                          value={form.phone}
                          onChange={handleChange}
                          placeholder="+91 98765 43210"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="you@email.com"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Message</label>
                      <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        placeholder="Tell us more..."
                        rows={4}
                      />
                    </div>
                  </>
                )}

                <button
                  type="submit"
                  className="btn-primary form-submit"
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Message →'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;